import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AntdThemeProvider } from './theme/components/AntdThemeProvider'
import { Router } from './routes'
import { CookieConsentComponent } from './components/CookieConsent'
const queryClient = new QueryClient()
import { I18nextProvider } from 'react-i18next'
import i18next from './i18n'

function App() {
  return (
    <div className="App h-screen">
      <I18nextProvider i18n={i18next} defaultNS={'translation'}>
        <AntdThemeProvider>
          <QueryClientProvider client={queryClient}>
            <Router />
            <CookieConsentComponent />
          </QueryClientProvider>
        </AntdThemeProvider>
      </I18nextProvider>
    </div>
  )
}

export default App
